"use client"
import { ReactNode, useEffect, useState } from "react"
import { useSessionContext } from "supertokens-auth-react/recipe/session"

import posthog from "posthog-js"
import { PostHogProvider as PHProvider } from "posthog-js/react"
import { FEATURE_FLAG_CONFIG, FeatureFlagProvider, SSGFeatureFlags } from "@contexts/FeatureFlagContext"

//TODO: https://github.com/vercel/next.js/issues/51581
//import PostHogPageView from "../PostHogPageView"
import dynamic from "next/dynamic"

const PostHogPageView = dynamic(() => import("@components/PostHog/PostHogPageView"), {
    ssr: false
})
type Props = { children: ReactNode; ssgFeatures: SSGFeatureFlags }

export function PostHogProvider({ children, ssgFeatures }: Props) {
    const session = useSessionContext()
    const [isPostHogInitialized, setIsPostHogInitialized] = useState(false)

    useEffect(() => {
        if (!!process.env.NEXT_PUBLIC_POSTHOG_KEY) {
            posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
                api_host: process.env.NEXT_PUBLIC_POSTHOG_HOST,
                ui_host: "https://us.posthog.com",
                loaded: (posthog) => {
                    // if (process.env.NODE_ENV === "development") posthog.debug()
                    window.posthog = posthog // Make PostHog available globally for debugging
                },
                person_profiles: "always", // or 'identified_only' to omit profiles for anonymous users
                capture_pageview: false, // Disable automatic pageview capture, as we capture manually
                capture_pageleave: true, // Enable pageleave capture -- TODO: do we care?
                bootstrap: {
                    featureFlags: FEATURE_FLAG_CONFIG // Use centralized feature flag configuration
                },
                // PostHog API doesn't explicitly document this in types, but it's available
                // @ts-ignore - feature_flag_polling_interval exists in recent PostHog versions
                feature_flag_polling_interval: 5 * 60 * 1000
            })
            setIsPostHogInitialized(true)
        }
    }, [])

    useEffect(() => {
        if (isPostHogInitialized && session.loading === false) {
            if (session.doesSessionExist && session.accessTokenPayload?.username) {
                posthog.identify(session.accessTokenPayload.username)
                // Reload feature flags after identification
                posthog.reloadFeatureFlags()
            }
        }
    }, [isPostHogInitialized, session])

    return (
        <FeatureFlagProvider value={ssgFeatures}>
            <PHProvider client={posthog}>
                <PostHogPageView />
                {children}
            </PHProvider>
        </FeatureFlagProvider>
    )
}
